function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.832.755L5 .75a2.75 2.75 0 012.745 2.582l.005.168V4h.75A1.5 1.5 0 0110 5.5v6A1.5 1.5 0 018.5 13h-7A1.5 1.5 0 010 11.5v-6A1.5 1.5 0 011.5 4h.75v-.5A2.75 2.75 0 014.832.755L5 .75l-.168.005zM5 7.5a1 1 0 100 2 1 1 0 000-2zm.128-5.244L5 2.25a1.25 1.25 0 00-1.244 1.122L3.75 3.5V4h2.5v-.5a1.25 1.25 0 00-1.122-1.244L5 2.25l.128.006z"
});

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    fill: "currentColor",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLock;